const activeClass = 'modal-active'
let modal = null
let link = null

const toggleModal = function(e) {
    e.preventDefault();
    link = this
    const target = document.querySelector(e.currentTarget.getAttribute('href'))
    modal = target

    if (modal.classList.contains(activeClass)) {
        closeModal();
    } else {
        openModal();
    }
}

const openModal = function() {
    modal.classList.add(activeClass)
    modal.setAttribute('aria-hidden', false)
    modal.setAttribute('aria-modal', true)
}

const closeModal = function() {
    if (modal === null) return
    modal.classList.remove(activeClass)
    modal.setAttribute('aria-hidden', true)
    modal.removeAttribute('aria-modal')
    modal = null
    link = null
}

document.querySelectorAll('.js-modal').forEach(a => {
    a.addEventListener('click', toggleModal)
})

document.addEventListener('click', function(e) {
    if (modal === null) return
    var isClickInside = modal.contains(e.target);
    var isClickLink = link.contains(e.target);
    if (isClickInside || isClickLink) return
    closeModal()
});